import React from 'react'
import Projects from './Components/Projects/Projects'
import "./App.css"

const App = () => {
  return (
    <div>
      <Projects></Projects>
    </div>
  )
}

export default App